import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_btn = _resolveComponent("async-btn")!

  return (_openBlock(), _createBlock(_component_async_btn, {
    task: _ctx.task,
    label: "Resend Code",
    class: "full-width",
    onClick: _ctx.resend
  }, null, 8, ["task", "onClick"]))
}